export default {
  'Sample photo': 'Foto de muestra',
  Removing: 'Quitando',
  Edit: 'Editar',
  'Adjust Picture': 'Ajustar imagen',
  Restore: 'Restaurar',
  Eraser: 'Borrador',
  Size: 'Tamaño',
  Background: 'Fondo',
  Custom: 'Uso general',
  Presets: 'Predeterminado',
  'Add Image': 'Agregar imagen',
  'Scale to Fit': 'Escalar para adaptarse',
  'Full Width': 'Ancho completo',
  'Full Height': 'Altura completa',
  Move: 'Mover',
  Undo: 'Deshacer',
  Redo: 'Rehacer',
  Enlarge: 'Agrandar',
  Reduce: 'Reducir',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPaw quitar fondo de imagen online',
    desc: 'Quitar fácilmente el fondo de tus fotos 100% automáticamente y gratis',
    imgAlt: 'photo background remover',
    submitBtn: 'Quitar fondo',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
    "Upload failed, click to try again": "Upload failed, click to try again",
};
